import React, { useEffect, useState } from "react";
import Footer from "../../footer/Footer";
import WOW from "wowjs";
import Sidenav from "../../../Pages/nav/Sidenav";
import Topnav from "../../../Pages/nav/Topnav";
import API from "../../../config/index";
import ImageComponent from "./studentProfilecard";
import { retrieveAuthToken } from "../../../api/authentication";

function Studentprofile() {
  const [isSidebarVisible, setSidebarVisible] = useState(true);
  const [erpNumber, setErpNumber] = useState("");
  const [studentData, setStudentData] = useState(null);
  const [error, setError] = useState("");
  const [isLoading, setLoading] = useState(false); // State for image loading

  useEffect(() => {
    const wow = new WOW.WOW();
    wow.init();
  }, []);

  const toggleSidebar = () => {
    setSidebarVisible(!isSidebarVisible);
  };

  const handleInputChange = (event) => {
    setErpNumber(event.target.value);
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    const token = retrieveAuthToken();
    setLoading(true); // Set loading state before fetching data
    try {
      const response = await fetch(`${API}/students/info/erpnum/${erpNumber}`, {
        method: "GET",
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
          schoolId: process.env.REACT_APP_SCHOOL_ID,
        },
      });
      if (!response.ok) {
        throw new Error(`${response.statusText}`);
      }
      const data = await response.json();
      if (data.length > 0) {
        setStudentData(data[0]); // Assuming studentData is an array and you need the first element
        setError("");
      } else {
        setError("Student data not found.");
        setStudentData(null);
      }
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      setError(`Error fetching data: ${error.message}`);
    } finally {
      setLoading(false); // Always clear loading state after fetching data
    }
  };

  return (
    <div className="nav-fixed">
      <Topnav toggleSidebar={toggleSidebar} />
      <div id="layoutSidenav">
        {isSidebarVisible && (
          <div>
            <Sidenav />
          </div>
        )}
        <div id="layoutSidenav_content">
          <div>
            <main>
              <div className="container-fluid p-3">
                <div className="row">
                  <form
                    className="row g-2 form-inline"
                    onSubmit={handleFormSubmit}
                  >
                    <div className="col-auto">
                      <input
                        type="text"
                        className="form-control"
                        name="erp"
                        placeholder="Enter ERP Number"
                        value={erpNumber}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="col-auto">
                      <button
                        className="btn btn-theme2"
                        type="submit"
                        id="getuserdetail"
                      >
                        Get Details
                      </button>
                    </div>
                    <div className="col-auto mt-3 editbutton">
                      <a className="textbutton color2 text-white" href=" ">
                        Edit Profile
                      </a>
                    </div>
                  </form>
                </div>
                {error && (
                  <div className="alert alert-danger mt-3" role="alert">
                    {error}
                  </div>
                )}

                {isLoading ? (
                  <div className="text-center mt-5">
                    <i className="fa fa-spinner fa-spin fa-3x"></i>
                  </div>
                ) : studentData ? (
                  <section
                    className="usersprofile userprofile mt-5 wow fadeInLeft"
                    id="usersprofile"
                  >
                    <div className="row mt-5 align-items-center">
                      <div className="col-12 col-lg-2 mb-3">
                        <div className="iconbox color2 up10">
                          <div className="iconval wow shake">
                            <i className="fa-solid fa-user-graduate"></i>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-lg-10 mb-3">
                        <h2 className="section-title mb-4">Student Profile</h2>
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-12 col-md-4 mb-4">
                        <div className="card">
                          {/* <img
                            src={studentData.image_url}
                            className="card-img-top img-fluid"
                            alt="profile"
                            onLoad={() => setLoading(false)} // Clear loading state when image loads
                            onError={() => setLoading(false)} // Clear loading state if image fails to load
                          /> */}

                          <ImageComponent imageUrl={studentData.image_url} />
                          <div className="card-body">
                            <h5 className="card-title">
                              ERP Number: {studentData.erp_num}
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-8">
                        <div className="row mb-4">
                          <div className="col-6">
                            <h5>Student Name:</h5>
                            <p className="mb-3">{studentData.full_name}</p>
                            <h5>Class:</h5>
                            <p className="mb-3">{studentData.class}</p>
                          </div>
                          <div className="col-6">
                            <h5>Aadhar</h5>
                            <p className="mb-3">{studentData.adhaar_no}</p>
                            <h5>DOB:</h5>
                            <p className="mb-3">{studentData.dob}</p>
                          </div>
                        </div>
                        <div className="row mb-4">
                          <div className="col-6">
                            <h5>Father's Name:</h5>
                            <p className="mb-3">{studentData.fathers_name}</p>
                          </div>
                          <div className="col-6">
                            <h5>Mother's Name:</h5>
                            <p className="mb-3">{studentData.mothers_name}</p>
                          </div>
                        </div>
                        <div className="row mb-4">
                          <div className="col-6">
                            <h5>Father's Occupation:</h5>
                            <p className="mb-3">
                              {studentData.fathers_occupation}
                            </p>
                          </div>
                          <div className="col-6">
                            <h5>Mother's Occupation:</h5>
                            <p className="mb-3">
                              {studentData.mothers_occupation}
                            </p>
                          </div>
                        </div>
                        <div className="row mb-4">
                          <div className="col-6">
                            <h5>Father's Qualification:</h5>
                            <p className="mb-3">
                              {studentData.fathers_qualification}
                            </p>
                          </div>
                          <div className="col-6">
                            <h5>Mother's Qualification:</h5>
                            <p className="mb-3">
                              {studentData.fathers_qualification}
                            </p>
                          </div>
                        </div>
                        <div className="row mb-4">
                          <div className="col-6">
                            <h5>Primary Contact:</h5>
                            <p className="mb-3">
                              {studentData.primary_phone || "Not Available"}
                            </p>
                            <h5>Alternate Contact:</h5>
                            <p className="mb-3">
                              {studentData.alternate_phone || "Not Available"}
                            </p>
                          </div>
                          <div className="col-6">
                            <h5>Permanent Address:</h5>
                            <p className="mb-3">
                              {studentData.permanent_address}
                            </p>
                            <h5>Present Address:</h5>
                            <p className="mb-3">
                              {studentData.present_address}
                            </p>
                          </div>
                        </div>
                        <div className="row mb-4">
                          <div className="col-6">
                            <h5>ID Mark1:</h5>
                            <p className="mb-3">{studentData.id_mark1}</p>
                          </div>
                          <div className="col-6">
                            <h5>ID Mark2:</h5>
                            <p className="mb-3">{studentData.id_mark2}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                ) : (
                  <div className="alert alert-info mt-3" role="alert">
                    Enter an ERP number and click "Get Details" to fetch student
                    data.
                  </div>
                )}
              </div>
            </main>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Studentprofile;
